import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `SwapAndBridgeControllerStateProvider` not mounted on RN.
export default function useSwapAndBridgeControllerState(): any {
  const { state } = useController('SwapAndBridgeController' as any)
  return state as any
}
